// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const DashboardSquaresIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M9 1.75H15C17.6576 1.75 19.435 2.31976 20.5576 3.44238C21.6802 4.565 22.25 6.3424 22.25 9V15C22.25 17.6576 21.6802 19.435 20.5576 20.5576C19.435 21.6802 17.6576 22.25 15 22.25H9C6.3424 22.25 4.565 21.6802 3.44238 20.5576C2.31976 19.435 1.75 17.6576 1.75 15V9C1.75 6.3424 2.31976 4.565 3.44238 3.44238C4.565 2.31976 6.3424 1.75 9 1.75ZM9 2.25C6.65972 2.25 4.92459 2.66134 3.79297 3.79297C2.66134 4.92459 2.25 6.65972 2.25 9V15C2.25 17.3403 2.66134 19.0754 3.79297 20.207C4.92459 21.3387 6.65972 21.75 9 21.75H15C17.3403 21.75 19.0754 21.3387 20.207 20.207C21.3387 19.0754 21.75 17.3403 21.75 15V9C21.75 6.65972 21.3387 4.92459 20.207 3.79297C19.0754 2.66134 17.3403 2.25 15 2.25H9Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M15.5 5.25C16.7439 5.25 17.75 6.25614 17.75 7.5V16.5C17.75 17.7439 16.7439 18.75 15.5 18.75C14.2561 18.75 13.25 17.7439 13.25 16.5V7.5C13.25 6.25614 14.2561 5.25 15.5 5.25ZM15.5 5.75C14.5339 5.75 13.75 6.53386 13.75 7.5V16.5C13.75 17.4661 14.5339 18.25 15.5 18.25C16.4661 18.25 17.25 17.4661 17.25 16.5V7.5C17.25 6.53386 16.4661 5.75 15.5 5.75Z"
        fill={fill}
        stroke={fill}
      />
      <path
        d="M8.5 19.25C6.98 19.25 5.75 18.02 5.75 16.5V13C5.75 11.48 6.98 10.25 8.5 10.25C10.02 10.25 11.25 11.48 11.25 13V16.5C11.25 18.02 10.02 19.25 8.5 19.25ZM8.5 11.75C7.81 11.75 7.25 12.31 7.25 13V16.5C7.25 17.19 7.81 17.75 8.5 17.75C9.19 17.75 9.75 17.19 9.75 16.5V13C9.75 12.31 9.19 11.75 8.5 11.75Z"
        fill={fill}
      />
    </svg>
  );
};

export { DashboardSquaresIcon };
